import axios, { AxiosError } from "axios";
import {
  jsonHeader,
  pmJwtHeader,
} from "@/apps/merchant3/services/apiClient/apiHeader";
import router from "@/router";
import logAction from "@/apps/merchant3/services/action-logs.service";
import ActionLogs from "@/apps/merchant3/types/ActionLogEvents";
import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import M3ErrorCodes from "@/apps/merchant3/types/M3ErrorCodes";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";
import { getCountryCode } from "@/apps/merchant3/helpers/flowType";

export const apiClient = axios.create({
  withCredentials: false,
  headers: jsonHeader(),
});

export const pmJwtApiClient = axios.create({
  withCredentials: false,
  headers: pmJwtHeader(),
});

const jwtApiClientFile = axios.create({
  withCredentials: false,
});

const responseHandler = (response) => {
  return response;
};

const errorHandler = async (error: AxiosError) => {
  // 2FA Face login error catch
  if (
    error.response?.status === 403 &&
    error.response?.data?.errorCode ===
      M3ErrorCodes.ERROR_FACE_LOGIN_REQUIRED &&
    error.response?.data?.loginType !== "qrCodeLogin"
  ) {
    router.push({
      name: RouteName.M3FaceLogin,
      params: { countryCode: getCountryCode(), clerkId: sessionStorage.getItem("PJ_clerk") },
    });
  }

  if (error.response?.status === 401) {
    logEvent(EventLogs.Events.SESSION_EXPIRED);
    await logAction(ActionLogs.Events.SESSION_EXPIRED);

    sessionStorage.clear();
    router.go(0);
  }
  return Promise.reject(error);
};

// Please use jwtApiClient once clerk is logged in
const merchantJwtClient = axios.create({
  withCredentials: false,
});

const jwtApiClient = axios.create({
  withCredentials: false,
});

// Dynamically set auth header to solve sync issue with sessionStorage
jwtApiClientFile.interceptors.request.use((config) => {
  const headers: Record<string, string> = {
    ...config.headers,
    "Content-Type": "multipart/form-data",
  };

  const jwt = sessionStorage.getItem(SessionStorageEnum.ClerkJwt);
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  config.headers = headers;
  return config;
});
merchantJwtClient.interceptors.request.use((config) => {
  const headers: Record<string, string> = {
    ...config.headers,
    "Content-Type": "application/json",
  };

  const jwt = sessionStorage.getItem(SessionStorageEnum.MerchantJwt);
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  config.headers = headers;
  return config;
});
jwtApiClient.interceptors.request.use((config) => {
  const headers: Record<string, string> = {
    ...config.headers,
    "Content-Type": "application/json",
  };

  const jwt = sessionStorage.getItem(SessionStorageEnum.ClerkJwt);
  if (jwt) {
    headers["Authorization"] = `Bearer ${jwt}`;
  }
  config.headers = headers;
  return config;
});

jwtApiClient.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

export { jwtApiClient, jwtApiClientFile, merchantJwtClient };
